/*=========================================================================================
  File Name: store.js
  Description: Vuex store
==========================================================================================*/

import Vue from "vue";
import Vuex from "vuex";
// import createLogger from "vuex/dist/logger";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex);

import moduleAuth from "./auth/moduleAuth.js";
import moduleNotifications from "./notifications/moduleNotifications.js";
import moduleTodoList from "@/store/todo-list/moduleTodoList";
import moduleProject from "@/store/project/moduleProject";

export default new Vuex.Store({
	getters,
	mutations,
	state,
	actions,
	modules: {
		auth: moduleAuth,
		notifications: moduleNotifications,
		todoListManagement: moduleTodoList,
		moduleProject: moduleProject
	},
	strict: process.env.NODE_ENV !== "production"
	// plugins: process.env.NODE_ENV !== "production" ? [createLogger()] : []
});
